import { PlusOutlined } from '@ant-design/icons';
import type { HeroSlide } from '@shop-monorepo/types';
import type { TableProps } from 'antd';
import { Button, Image } from 'antd';
import React from 'react';
import { generatePath } from 'react-router-dom';

import { DeleteButton } from '@/components/DeleteButton';
import { EditButton } from '@/components/EditButton';
import {
  PageContainer,
  PageHeader,
  PageTitle,
  StyledTable,
  TableContainer,
  Toolbar,
} from '@/components/PageLayout';
import { RightAlignedSpace } from '@/components/RightAlignedSpace';
import { StatusIndicator } from '@/components/StatusIndicator';
import { useDeleteHeroSlide, useHeroSlides } from '@/hooks/useHeroSlideQueries';
import { useListNavigate } from '@/hooks/useListReturn';
import { ROUTES } from '@/routes/routes';

export const HeroSlidesPage: React.FC = () => {
  const goToDetail = useListNavigate();
  const { data: slides, isLoading } = useHeroSlides();
  const { mutate: deleteSlide } = useDeleteHeroSlide();

  const columns: TableProps<HeroSlide>['columns'] = [
    {
      title: 'Зображення',
      dataIndex: 'image',
      key: 'image',
      render: (image: string, record) => (
        <Image
          src={image}
          alt={record.title}
          width={120}
          height={64}
          style={{ objectFit: 'cover', borderRadius: 6 }}
          preview={false}
        />
      ),
    },
    {
      title: 'Заголовок',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Порядок',
      dataIndex: 'sortOrder',
      key: 'sortOrder',
    },
    {
      title: 'Статус',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive: boolean) => <StatusIndicator isActive={isActive} />,
    },
    {
      title: 'Дія',
      key: 'action',
      align: 'right',
      render: (_, record) => (
        <RightAlignedSpace size="middle">
          <EditButton
            onClick={() =>
              goToDetail(generatePath(ROUTES.HERO_SLIDE_EDIT, { id: String(record.id) }))
            }
          />
          <DeleteButton onConfirm={() => deleteSlide(record.id)} entityName={record.title} />
        </RightAlignedSpace>
      ),
    },
  ];

  return (
    <PageContainer>
      <PageHeader>
        <PageTitle>Слайдер</PageTitle>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => goToDetail(ROUTES.HERO_SLIDE_CREATE)}
        >
          Додати слайд
        </Button>
      </PageHeader>
      <Toolbar>{/* filters placeholder */}</Toolbar>
      <TableContainer>
        <StyledTable
          columns={columns}
          dataSource={slides || []}
          rowKey="id"
          loading={isLoading}
          pagination={false}
          scroll={{ x: 800 }}
        />
      </TableContainer>
    </PageContainer>
  );
};
